// biome-ignore lint/style/noRestrictedImports: encapsulation
import { take as take_ } from "remeda";

import { unpurry } from "./_unpurry";

export const take = unpurry(take_, 2);
